export default __webpack_public_path__ + "static/media/triangle.bf792c06.wav";